export class TvshopConstants {
  static LOCALE_ARRAY = ['nl', 'fr', 'en'];
  static CUSTOMER_NUMBER_KEY = 'customer_number';
  static DTV_IDENTIFIER_KEY = 'dtv_identifier';
  static IMAGES_AEM_PATH = '/content/dam/www-telenet-be/tv-shop/img/';
  static CAROUSEL_LOGOS_AEM_PATH = '/content/dam/www-telenet-be/tv-shop/carousel-logos/';
  static SCROLL_TEXT_AMOUNT = 15;
  static VIDEOS_AEM_PATH = '/content/dam/www-telenet-be/tv-shop/trailers/';
  static MAXIMUM_ORDERING_COOL_DOWN_IN_MS = 60000;
  static SUBMITTING_STATE = 'Submitting';
}
